import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from '@/services/utils/figureFormatter';
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
import { useStore } from 'vuex';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const pdfPrinter = () => {
    const { getHeader, getFooter } = pdfHeaderFooter();
    const store = useStore();
    const { commaFormat } = figureFormatter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, data, startDate, endDate, qrcode, filterText = 'Filters: All') => {
        const doc = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [12, 100, 12, 80],
            header: getHeader(company),
            footer: getFooter(userName, qrcode),
            content: getContent(data, startDate, endDate, filterText),
            defaultStyle: { color: 'black', fontSize: getFontSize(data.amount_heads) },
            info: { title: 'Marketing Team Wise Collection Report' }
        }

        pdfMake.createPdf(doc).open();
    }

    const getFontSize = (amountHeads) => {
        if (amountHeads.length > 10) return 5.5;
        if (amountHeads.length > 8) return 6;
        if (amountHeads.length > 6) return 7;
        return 8;
    }

    const getDateRangeText = (startDate, endDate) => {
        if (! startDate) return 'Date: All'
        if (! endDate) return 'Date: All'
        return `Date: ${startDate} - ${endDate}`
    }

    const getContent = (data, startDate, endDate, filterText) => {
        const { rows, totals, amount_heads: amountHeads } = data;

        return [
            {
                text: 'Marketing Team Wise Collection Report',
                fontSize: 14,
                bold: true,
                alignment: 'center',
                decoration: 'underline',
                margin: [0, 0, 0, 4]
            },
            { text: getDateRangeText(startDate, endDate), margin: [0, 0, 0, 2] },
            { text: filterText, margin: [0, 0, 0, 8] },
            {
                fontSize: getFontSize(amountHeads),
                table: {
                    headerRows: 1,
                    widths: getColumnWidths(amountHeads),
                    body: getTableBody(rows, totals, amountHeads)
                },
                layout: {
                    fillColor: (rowIndex) => {
                        if (rowIndex === 0) return '#f3f2f7'
                        return null
                    },
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5,
                    paddingLeft: () => 1.5,
                    paddingRight: () => 1.5,
                    paddingTop: () => 1,
                    paddingBottom: () => 1
                }
            }
        ]
    }

    const getColumnWidths = (amountHeads) => {
        if (amountHeads.length > 6) {
            const widths = [22, 52, 44, '*', 20, 'auto'];
            return widths.concat(amountHeads.map(() => '*'));
        }

        const widths = ['auto', '*', 'auto', '*', 'auto', 'auto'];
        return widths.concat(amountHeads.map(() => 'auto'));
    }

    const cleanText = (value) => {
        if (! value) return ''
        return value
    }

    const getCell = (row, key) => {
        if (! row.amounts) return 0
        if (! row.amounts[key]) return 0
        return row.amounts[key]
    }

    const getTotalCell = (totals, key) => {
        if (! totals.amounts) return 0
        if (! totals.amounts[key]) return 0
        return totals.amounts[key]
    }

    const collectedAmountText = (value) => {
        if (! value) return '-'
        return commaFormat(value, 0)
    }

    const getTableBody = (rows, totals, amountHeads) => {
        const header = [
            { text: 'ID', bold: true },
            { text: 'Marketing Team', bold: true },
            { text: 'Mobile No', bold: true },
            { text: 'Shareholder Name', bold: true },
            { text: 'No of SH', bold: true, alignment: 'right' },
            { text: 'Total Money Received', bold: true, alignment: 'right' },
            ...amountHeads.map((head) => ({ text: head.label, bold: true, alignment: 'right' }))
        ];

        const dataRows = rows.map((row) => [
            { text: cleanText(row.serial_no) },
            { text: `${cleanText(row.employee_name)} (${cleanText(row.serial_no)})` },
            { text: cleanText(row.mobile_no) },
            { text: cleanText(row.shareholder_names) },
            { text: row.no_of_shareholders, alignment: 'right' },
            { text: commaFormat(row.total_received), alignment: 'right' },
            ...amountHeads.map((head) => ({
                text: collectedAmountText(getCell(row, head.key)),
                alignment: 'right'
            }))
        ]);

        const totalRow = [
            { text: 'Total', bold: true, colSpan: 4 }, {}, {}, {},
            { text: totals.no_of_shareholders, bold: true, alignment: 'right' },
            { text: commaFormat(totals.total_received), bold: true, alignment: 'right' },
            ...amountHeads.map((head) => ({
                text: collectedAmountText(getTotalCell(totals, head.key)),
                bold: true,
                alignment: 'right'
            }))
        ];

        return [header, ...dataRows, totalRow];
    }

    return { exportToPDF }
}

export default pdfPrinter;
